const Anontools = () => null;

export default Anontools;
